<template>
    <v-col cols="12" class="mt-6">
        <v-row justify="center" justify-lg="space-between">
            <v-col cols="12" md="6" lg="4" align="center" class="px-4">
                <v-card class="px-6 pb-6 pt-3 pt-xl-6 bg-pending" elevation="12" height="170" to="/user/library">
                    <v-row  align="center">
                        <v-col cols="7" xl="9" class="white--text text-left text-h5 font-weight-regular">
                            {{ $t('home.pending_readings') }}
                            <p class="py-2 text-left text-subtitle-1 text-lg-subtitle-1">
                                {{ $t('home.pending_readings_desc') }}
                            </p>
                        </v-col>
                    </v-row>
                    <v-overlay absolute value="true" opacity="0" class="overlayTwo">
                        <v-img src="/img/user/books-bg.svg" max-height="160" max-width="160"></v-img>
                    </v-overlay>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" lg="4" align="center" class="pr-5">
                <v-card class="pa-6 bg-challenges" elevation="12" height="170" to="/user/challenge">
                    <v-row align="center">
                        <v-col cols="8" xl="9" class="white--text text-left text-h5 font-weight-regular">
                            {{ $t('home.challenges') }}
                            <p class="py-2 text-left text-subtitle-1 text-lg-subtitle-1">
                                {{ $t('home.challenges_desc') }}
                            </p>
                        </v-col>
                    </v-row>
                    <v-overlay absolute value="true" opacity="0" class="overlayOne">
                        <v-img src="/img/user/challenges-bg.svg" max-height="160" max-width="160"></v-img>
                    </v-overlay>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" lg="4" align="center" class="pl-5">
                <v-card class="pa-4 bg-store" elevation="12" height="170" to="/user/store">
                    <v-row align="center">
                        <v-col cols="7" xl="9" class="white--text text-left text-h5 font-weight-regular">
                            {{ $t('home.store') }}
                            <p class="py-2 text-left text-subtitle-1 text-lg-subtitle-1">
                                {{ $t('home.store_desc') }}
                            </p>
                        </v-col>
                    </v-row>
                    <v-overlay absolute value="true" opacity="0" class="overlayThree">
                        <v-img src="/img/user/store-bg.svg" max-height="220" max-width="220"></v-img>
                    </v-overlay>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    
}
</script>
<style scoped>
.v-card {
    border-radius: 20px;
}
.bg-challenges {
    background: rgb(109,91,175);
    background: linear-gradient(90deg, rgba(109,91,175,1) 0%, rgba(109,91,175,1) 40%, rgba(178,158,233,1) 100%);
}

.bg-pending {
    background: #2DBBAD;
}

.bg-store {
    background: rgb(207,73,154);
    background: linear-gradient(90deg, rgba(207,73,154,1) 0%, rgba(134,116,184,1) 50%, rgba(47,165,218,1) 100%);
}

.overlayOne {
    justify-content: flex-end;
    margin-right: -10px;
}

.overlayTwo {
    justify-content: flex-end;
    margin-right: -15px;
}

.overlayThree {
    justify-content: flex-end;
    margin-right: -50px;
    margin-bottom: -40px;
}

</style>